import { render, staticRenderFns } from "./kplh-template-sedang.vue?vue&type=template&id=9b421532&"
import script from "./kplh-template-sedang.vue?vue&type=script&lang=js&"
export * from "./kplh-template-sedang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports